import { Get } from "services/apiService";
import { BASE_URL, SOMS_API_KEY } from "services/CONSTANTS";
import {
  GET_REASON_CODES_REQUEST,
  GET_REASON_CODES_SUCCESS,
  GET_REASON_CODES_ERROR,
  CLEAR_REASON_CODES_REQUEST,
} from "redux/actions/action-type";

export const getResonCodes =
  ({ status }) =>
  async (dispatch) => {
    const apiUrl = `${BASE_URL}reasoncodes?status=${status}&apikey=${SOMS_API_KEY}`;
    dispatch({ type: GET_REASON_CODES_REQUEST });
    Get({ url: apiUrl })
      .then((response) => {
        if (response.status === 200)
          dispatch({ type: GET_REASON_CODES_SUCCESS, payload: response.data });
        else
          dispatch({
            type: GET_REASON_CODES_ERROR,
            payload:
              response.data.errorMessage ||
              "Error occurred while fetching reasons.",
          });
      })
      .catch((error) => {
        dispatch({
          type: GET_REASON_CODES_ERROR,
          payload: error.message || "Error occurred while fetching reasons.",
        });
      });
  };

export const clearReasonCodes = () => async (dispatch) => {
  dispatch({ type: CLEAR_REASON_CODES_REQUEST });
};
